<template>
  <v-card elevation="0" color="transparent">
    <v-card-text class="pb-0 pl-0 pr-0" data-cy="listFilter-quick-input">
      <v-text-field
        clearable
        label="Search"
        outlined
        v-model="filterString"
        @input="updateEntityListFiltered"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
import { pick } from "lodash";

import { hasValue, normalizeValue } from "@/lib/componentUtil";

import listFilterMixin from "./listFilterMixin";

export default {
  methods: {
    filter(entityListFormatted, filterString) {
      const { attributeListSelected } = this;

      const filterTermList = filterString
        // filterTermSeparator is defined in mixin
        .split(this.filterTermSeparator)
        .filter(hasValue)
        .map(normalizeValue);

      // Return a list of entities that have at least one value that matches at least one search term
      return entityListFormatted.filter(entityHasMatch);

      function entityHasMatch(entity) {
        // Reduce the entity to just the selected attributes
        const entitySelectedAttributes = pick(
          entity,
          attributeListSelected.map(({ name }) => name)
        );

        const entityValueList = Object.values(entitySelectedAttributes)
          .filter(hasValue)
          .map(normalizeValue);

        // Array.find() will exit on first value match
        return !!entityValueList.find(
          // Array.find() will exit on first term match
          value => {
            if (typeof value === "number") value = value.toString()
            return !!filterTermList.find(filterTerm => {
              return !!value.includes(filterTerm)
          })
          }
        );
      }
    },
  },
  mixins: [listFilterMixin],
  props: {
    attributeListSelected: {
      required: true,
      type: Array,
    },
  },
};
</script>
